import { createRef } from "react";

export const notistackRef = createRef<any>();
